import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-reportplantcut',
  templateUrl: './reportplantcut.component.html',
  styleUrls: ['./reportplantcut.component.css']
})
export class ReportplantcutComponent implements OnInit, OnDestroy {


  constructor(private spinner: NgxSpinnerService,private route: ActivatedRoute) { 
    this.Nowdate();
    
  }
  today;
  id: any;
  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('grouptype');
    this.LoadListGroupRepair();
  }

  Nowdate(){
    const date = new Date()
    const result = date.toLocaleDateString('th-TH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
  this.today = result;
  }

  datagroup:any;
  Getsupgroup() {
    let text = (<HTMLInputElement>document.getElementById("groupcode")).value;
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_groupCode")
      .then((out: any) => {
        const data = out.data.recordset;
        this.datagroup = data.filter(element => element.groupcode == text)
      })
      .catch(err => { throw err });
  }

  // กลุ่มตัด 
  datareportplantcup:any;
  Loadreportplantcup(){
    this.spinner.show();
    this.Getsupgroup();
    let text = (<HTMLInputElement>document.getElementById("groupcode")).value;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_cp6465bygroupCode_from?groupCode="+ text;
    axios.get(url)
    .then(res => {
      this.datareportplantcup = res.data.recordset;
      if (res.data.rowsAffected == 0)
      {alert("ไม่มีข้อมูล");}
    }).catch(err => {throw(err)})
    this.spinner.hide();
  }

  // กลุ่มบำรุง
  datareportplantrepair:any;
  sunland:any;
  Loadreportplantrepair(){
    this.spinner.show();
    this.Getsupgroup();
    this.Loadtoolsrepair();
    let text = (<HTMLInputElement>document.getElementById("groupcode")).value;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_cp6566_visitFM_m_w?groupCode_m="+ text;
    axios.get(url)
    .then(res => {
      this.datareportplantrepair = res.data.recordset; 
      // this.datareportplantrepair.sort(this.dynamicSort("fmname"));
     
      this.sunland = [];              
      if (res.data.rowsAffected == 0)
      {alert("ไม่มีข้อมูล");}
    }).catch(err => {throw(err)})
    this.spinner.hide();
  }

  // รายการเครื่องมือ
  toolsrepair:any;
  Loadtoolsrepair(){
    this.spinner.show();
    let text = (<HTMLInputElement>document.getElementById("groupcode")).value;
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_groupCode_HMn0_w?groupcode="+ text;
    axios.get(url)
    .then(res => {
      this.toolsrepair = res.data.recordset;
      if (res.data.rowsAffected == 0)
      {alert("ไม่มีข้อมูลรายการเครื่องมือ อุปกรณ์ ในกลุ่ม");}
    }).catch(err => {throw(err)})
    this.spinner.hide();
  }

  ungroup:any;
  Loadreportplantrepairbyzone(){
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_cp6566_visitFM_w0?supzone="+ this.ungroup;
    axios.get(url)
    .then(res => {
      this.datareportplantrepair = res.data.recordset; 
      this.datareportplantrepair.sort(this.dynamicSort("fmname"));
      let ER = this.datareportplantrepair.filter(el => el.canetype == 'ER');
      let SR = this.datareportplantrepair.filter(el => el.canetype == 'SR');
      let ST = this.datareportplantrepair.filter(el => el.canetype.slice(0,2) == 'ST');
      this.sunland = [{ 'sunplant': res.data.rowsAffected,
                        'sumlandvalue': (this.datareportplantrepair.map((el:any) => { return parseFloat(el.landvalue)})).reduce((a, b) => a + b, 0),
                        'sumAssess': (this.datareportplantrepair.map((el:any) => { return parseFloat(el.Assess)})).reduce((a, b) => a + b, 0),
                        'sumlandton': (this.datareportplantrepair.map((el:any) => { return parseFloat(el.ton)})).reduce((a, b) => a + b, 0)/res.data.rowsAffected,
                        'sumER': (ER.map((el:any) => { return parseFloat(el.ton)})).reduce((a, b) => a + b, 0)/ER.length,
                        'sumSR': (SR.map((el:any) => { return parseFloat(el.ton)})).reduce((a, b) => a + b, 0)/SR.length,
                        'sumST': (ST.map((el:any) => { return parseFloat(el.ton)})).reduce((a, b) => a + b, 0)/ST.length,
                      }];
     
      if (res.data.rowsAffected == 0)
      {alert("ไม่มีข้อมูล");}
    }).catch(err => {throw(err)})
    this.spinner.hide();
  }
  repairtg:any;
  LoadListGroupRepair(){
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_groupCode_HM_w?category=M")
    .then(res => {
      this.repairtg = res.data.recordset;
      if (res.data.rowsAffected == 0)
      {alert("ไม่มีข้อมูลแปลง");}
    }).catch(err => {throw(err)})
    this.spinner.hide();
  }

  print(){
    window.print();
  }

  dynamicSort(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        /* next line works with strings and numbers, 
         * and you may want to customize it to your needs
         */
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}
 
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.datareportplantcup = null;
    this.datareportplantrepair = null;
    this.datagroup = null;
    this.repairtg = null;
    this.toolsrepair = null;
  }
}
